// Design System for Secret Hitler
export const Colors = {
  primary: '#ffd700',
  secondary: '#ff6b6b', 
  success: '#4CAF50',
  danger: '#f44336',
  warning: '#ffc107',
  info: '#2196F3',
  dark: '#1a1a1a',
  light: '#ffffff',
  glass: 'rgba(255, 255, 255, 0.1)',
  glassBorder: 'rgba(255, 255, 255, 0.2)',
  glassDark: 'rgba(26, 26, 26, 0.9)',
  glassDarkBorder: 'rgba(40, 40, 40, 0.9)'
};

export const Shadows = {
  small: '0 2px 8px rgba(0, 0, 0, 0.15)',
  medium: '0 4px 16px rgba(0, 0, 0, 0.2)',
  large: '0 8px 32px rgba(0, 0, 0, 0.3)',
  glow: '0 0 20px rgba(255, 215, 0, 0.3)',
  glowSuccess: '0 0 20px rgba(76, 175, 80, 0.3)',
  glowDanger: '0 0 20px rgba(244, 67, 54, 0.3)'
};

export const BorderRadius = {
  small: '8px',
  medium: '15px', 
  large: '25px',
  round: '50%'
};

export const Typography = {
  heading: "'Cinzel', serif",
  body: "'Inter', sans-serif",
  display: "'Cinzel', serif"
};

export const Spacing = {
  xs: '0.5rem',
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
  xl: '3rem',
  xxl: '4rem'
};

export const Transitions = {
  fast: 'all 0.2s ease',
  normal: 'all 0.3s ease',
  slow: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
};

// Mobile-specific breakpoints
export const Breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1200px'
};

// Mobile-specific spacing
export const MobileSpacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '0.75rem',
  lg: '1rem',
  xl: '1.5rem'
}; 